<template>
  <router-link-modified v-if="hasInteraction"
                        :to="{ name: 'account-interaction', params: { id: responseData.interaction.id }}"
                        class="base-btn base-btn--outline-blue">
    <span class="base-btn__text">{{ $tResumePage('Interaction: ' + $get(responseData.interaction, 'status')) }}</span>
  </router-link-modified>

  <div v-else-if="isInvited"
       style="cursor:default;"
       class="_invited  base-btn">
    <span class="base-btn__text">
      <span class="resume-main__btn-text-gray">{{ $tResumePage('Invite sent') }}</span>
      <span style="white-space: pre-wrap">
        {{ $get(responseData, 'invite_send_date') | formatDate(true) }}
      </span>
    </span>
  </div>

  <div v-else-if="hasInteractionFromAnotherEmployer"
       style="cursor:default;"
       class="_invited  base-btn">
    <span class="base-btn__text">
      <span class="resume-main__btn-text-gray">{{ $tResumePage('Settled for another job') }}</span>
    </span>
  </div>

  <button v-else
      class="base-btn base-btn--outline-blue"
      type="button"
      @click="$emit('accept')">
    <BaseSvg name="ico-plus" width="1.3rem" height="1.3rem"/>
    <span class="base-btn__text">{{ $tResumePage("To hire") }}</span>
  </button>
</template>

<script>
  export default {
    name: 'ResumeAcceptBtn',
    props: {
      isInvited: {
        type: Boolean,
        default: false,
      },
      isRejected: {
        type: Boolean,
        default: false,
      },
      hasInteraction: {
        type: Boolean,
        default: false,
      },
      hasInteractionFromAnotherEmployer: {
        type: Boolean,
        default: false,
      },
      responseData: {
        type: Object,
      },
    }
  }
</script>

<style lang="less">

</style>
